<tt-page *ngIf="!!edit">
    <tt-card class="col-xs-12 col-md-4 sp-0">
        <tt-input ttLabel="table_name" [ttModel]="edit.table_name" ttReadonly></tt-input>
        <tt-input ttLabel="statsource_heading" [(ttModel)]="edit.statsource_heading" ttRequired></tt-input>
        <tt-textarea ttLabel="statsource_description" [(ttModel)]="edit.statsource_description"></tt-textarea>
        <tt-button-save ttText="dataminingcreate_save" (ttClick)="saveChanges()" [ttLoading]="saving"></tt-button-save>
    </tt-card>
</tt-page>
